export default "__VITE_ASSET__DVf9c5WR__"